import { Component, OnDestroy, OnInit } from '@angular/core'
import { FetchSettingsRequest } from '@containers/settings/settings.actions'
import { getSettingsState } from '@containers/settings/settings.selectors'
import { select, Store } from '@ngrx/store'
import { Subscription } from 'rxjs'
import { environment } from '../../../environments/environment'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.css'],
})
export class AuthLayoutComponent implements OnInit, OnDestroy {
  public settings$: Subscription
  public settings: any
  public title: string
  public description: string
  public footer: SafeHtml

  constructor(public store: Store<any>, private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.settings$ = this.store
      .pipe(select(getSettingsState))
      .subscribe((state) => {
        this.settings = state.get('data').toJS()

        this.title = this.settings?.ui?.SETTINGS_UI_TITLE
        this.description = this.settings?.ui?.SETTINGS_UI_DESCRIPTION
        this.footer = this.sanitizer.bypassSecurityTrustHtml(
          this.settings?.ui?.SETTINGS_UI_FOOTER,
        )
      })

    this.store.dispatch<any>(new FetchSettingsRequest())
  }

  getLoginImage() {
    return `${environment.API_ENDPOINT}/public/image/loginLogo`
  }

  ngOnDestroy(): void {
    this.settings$.unsubscribe()
  }
}
